import { createReducer } from '@reduxjs/toolkit';

import { SortDirections } from 'models/app/applicationState';

import { withTotalCount } from 'services/http/http.helpers';

import { SET_QUERY_PARAMS } from 'store/application/action.types';
import { CLEAR_CURRENT_USER } from 'store/current-user/actions.types';
import {
    updateStandardListDataQueryParams,
    updateStandardLists,
    updateStandardListsOnCleanup,
    updateStandardListsOnFailure,
    updateStandardListsOnSuccess,
} from 'store/standardLists.helpers';
import { transactionDetailsPerLocationStoreKeyName } from 'store/transaction/reducer';

import {
    CLEAR_TRANSACTIONS_LIST,
    DOWNLOAD_RECEIPT_ATTACHMENT,
    DOWNLOAD_RECEIPT_ATTACHMENT_FAILURE,
    DOWNLOAD_RECEIPT_ATTACHMENT_SUCCESS,
    FETCH_TRANSACTION_DETAILS_FAILURE,
    FETCH_TRANSACTION_DETAILS_SUCCESS,
    FETCH_TRANSACTIONS_LIST,
    FETCH_TRANSACTIONS_LIST_FAILURE,
    FETCH_TRANSACTIONS_LIST_SUCCESS,
    HIDE_DOWNLOAD_RECEIPT_ATTACHMENT_FORM,
    SHOW_DOWNLOAD_RECEIPT_ATTACHMENT_FORM,
} from './actions.types';


export const transactionsReducerName = 'transactions';
export const transactionsListsPerLocationStoreKeyName = 'transactionsListsPerLocation';

export const defaultTransactionsListQueryParams = {
    limit: 20,
    offset: 0,
    type: undefined,
    currency: undefined,
    companyId: undefined,
    businessUserId: undefined,
    sortBy: 'createdAt',
    sortOrder: SortDirections.DESCEND,
    ...withTotalCount,
};

export const transactionsInitialListState = {
    [transactionsListsPerLocationStoreKeyName]: {},
    downloadReceiptAttachment: {},
    downloadPdfStatement: {},
};

const createTransactionsBuilderCases = (builder) =>
    builder
        .addCase(FETCH_TRANSACTIONS_LIST, (state, action) => {
            state[transactionsListsPerLocationStoreKeyName] = updateStandardLists({
                listsState: state[transactionsListsPerLocationStoreKeyName],
                action,
            });
        })
        .addCase(FETCH_TRANSACTIONS_LIST_SUCCESS, (state, action) => {
            state[transactionsListsPerLocationStoreKeyName] = updateStandardListsOnSuccess({
                listsState: state[transactionsListsPerLocationStoreKeyName],
                action,
            });
        })
        .addCase(FETCH_TRANSACTIONS_LIST_FAILURE, (state, action) => {
            state[transactionsListsPerLocationStoreKeyName] = updateStandardListsOnFailure({
                listsState: state[transactionsListsPerLocationStoreKeyName],
                action,
            });
        })
        .addCase(CLEAR_TRANSACTIONS_LIST, (state, action) => {
            state[transactionsListsPerLocationStoreKeyName] = updateStandardListsOnCleanup({
                listsState: state[transactionsListsPerLocationStoreKeyName],
                action,
            });
        })
        .addCase(SET_QUERY_PARAMS, (state, action) => {
            if (
                action.payload?.reducerName === transactionsReducerName
        && action.payload?.fieldName === transactionsListsPerLocationStoreKeyName
            ) {
                state[transactionsListsPerLocationStoreKeyName] = updateStandardListDataQueryParams({
                    listsState: state[transactionsListsPerLocationStoreKeyName],
                    action,
                });
            }
        })
        .addCase(CLEAR_CURRENT_USER, () => transactionsInitialListState)

        .addCase(FETCH_TRANSACTION_DETAILS_SUCCESS, (state, action) => {
            const { locationPathname, transaction } = action.payload;

            if (!state[transactionDetailsPerLocationStoreKeyName]) {
                state[transactionDetailsPerLocationStoreKeyName] = {};
            }

            state[transactionDetailsPerLocationStoreKeyName][locationPathname] = transaction;
        })

    // .addCase(FETCH_TRANSACTION_DETAILS_SUCCESS, (state, action) => {
    //   const { locationPathname, transaction } = action.payload;
    //   state[transactionDetailsPerLocationStoreKeyName][locationPathname] =
    //     transaction;
    // })

        .addCase(FETCH_TRANSACTION_DETAILS_FAILURE, (state, action) => {
            const { locationPathname } = action.payload;
            state[transactionDetailsPerLocationStoreKeyName][locationPathname] = { error: true };
        })

    // ✅ Show/hide form
        .addCase(SHOW_DOWNLOAD_RECEIPT_ATTACHMENT_FORM, (state, action) => {
            const { receiptId } = action.payload;
            state.downloadReceiptAttachment[receiptId] = {
                ...(state.downloadReceiptAttachment[receiptId] || {}),
                isFormVisible: true,
                isDownloading: false,
            };
        })

        .addCase(HIDE_DOWNLOAD_RECEIPT_ATTACHMENT_FORM, (state, action) => {
            const { receiptId } = action.payload;
            if (state.downloadReceiptAttachment[receiptId]) {
                state.downloadReceiptAttachment[receiptId].isFormVisible = false;
            }
        })

    // ✅ Downloading logic
        .addCase(DOWNLOAD_RECEIPT_ATTACHMENT, (state, action) => {
            const { receiptId } = action.payload.queryParams;
            state.downloadReceiptAttachment[receiptId] = {
                ...(state.downloadReceiptAttachment[receiptId] || {}),
                isDownloading: true,
            };
        })

        .addCase(DOWNLOAD_RECEIPT_ATTACHMENT_SUCCESS, (state, action) => {
            const { receiptId } = action.payload;
            if (state.downloadReceiptAttachment[receiptId]) {
                state.downloadReceiptAttachment[receiptId].isDownloading = false;
                state.downloadReceiptAttachment[receiptId].isFormVisible = false;
            }
        })

        .addCase(DOWNLOAD_RECEIPT_ATTACHMENT_FAILURE, (state, action) => {
            const { receiptId } = action.payload;
            if (state.downloadReceiptAttachment[receiptId]) {
                state.downloadReceiptAttachment[receiptId].isDownloading = false;
            }
        });

export default createReducer(
    transactionsInitialListState,
    createTransactionsBuilderCases,
);
